export default [
  {
    title: 'หน้าหลัก',
    route: 'home-dashboard',
    icon: 'HomeIcon',
    resource: 'normal',
    action: 'manage',
  },
  {
    title: 'เชื่อมต่อ Telegram',
    route: 'connect',
    icon: 'LinkIcon',
    resource: 'normal',
    action: 'manage',
  },
  // {
  //   title: 'นำเข้าแบบถูกต้อง',
  //   route: 'formal-import',
  //   icon: 'FileTextIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'สั่งสินค้า',
  //   route: 'customer-orders-order',
  //   icon: 'ShoppingBagIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'ตะกร้าของฉัน',
  //   route: 'customer-orders-cart',
  //   icon: 'ShoppingCartIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'รายละเอียดการสั่งซื้อ',
  //   route: 'customer-orders-detail',
  //   icon: 'EditIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'เชคการส่งของ',
  //   route: 'customer-orders-delivery',
  //   icon: 'CheckCircleIcon',
  // },
]
